import { render, staticRenderFns } from "./PurchaseingList.vue?vue&type=template&id=4b83de98&"
import script from "./PurchaseingList.vue?vue&type=script&lang=ts&"
export * from "./PurchaseingList.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseingList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports